import * as React from 'react'

export const UserExperienceDesign: React.FC = () => (
  <svg
    version='1.1'
    id='Layer_1'
    xmlns='http://www.w3.org/2000/svg'
    x='0'
    y='0'
    viewBox='0 0 210 210'
    xmlSpace='preserve'
  >
    <style>
      {
        '.st0{fill:none;stroke:var(--color-badge-text);stroke-width:1.25;stroke-miterlimit:10}.st1{enable-background:new;fill:var(--color-badge-text)}.st2{fill:none;stroke:#3c388f;stroke-width:1.25;stroke-miterlimit:9.9999}.st4{fill:#a5a5ff}.st5{fill:none;stroke:var(--color-badge-text);stroke-width:1.25;stroke-linecap:round;stroke-linejoin:round}'
      }
    </style>
    <path
      className='st0'
      d='M148.4 57.5c30.4 23.9 35.6 67.9 11.7 98.3s-67.9 35.6-98.3 11.7-35.6-67.9-11.7-98.3c3.4-4.3 7.3-8.3 11.7-11.7'
    />
    <path
      d='m11.1 125.4-9.7.7-.1-1.8 9.5-.7c2.4-.2 3.4-1.6 3.2-4-.2-2.3-1.3-3.5-3.7-3.3l-9.6.7-.1-1.8 9.7-.7c3.5-.3 5 2 5.2 5.1.2 3-1 5.5-4.4 5.8zM10.1 108.4l.2-1.8c2.4 0 3.8-1.3 4.1-4 .2-2-.5-3.5-2.3-3.7-1.9-.2-2.6 1.5-3.4 3.9-.8 2.4-1.8 4.5-4.5 4.2-2.3-.2-3.6-2.3-3.2-5.2.4-3.6 2.3-4.8 5-4.9l-.2 1.7c-2.1 0-3.2 1.2-3.4 3.3-.2 1.9.5 3.3 1.9 3.4 1.6.2 2.3-1.4 2.9-3.5.8-2.7 1.8-5.2 5-4.8 2.7.3 3.9 2.6 3.6 5.7-.4 4.2-2.8 5.9-5.7 5.7zM3.5 88.3l2.8-9.7 1.5.4-2.3 8 4.3 1.3 2.1-7.2 1.5.4-2.1 7.2 4.8 1.4 2.4-8.2 1.6.5-2.9 9.9-13.7-4zM9.3 70.8l3-6c1.1-2.3 3.3-3.1 5.4-2 1.6.8 2.3 2 2.1 3.8h.1c1.1-1.1 2.2-1 4.2-.2 2.1.9 2.8.9 3 .8h.1l-1 1.8c-.4.2-.9 0-3.1-1-1.9-.8-3-.4-3.8 1.3l-1.8 3.6 5.4 2.7-.8 1.6-12.8-6.4zm6.9 1.5 1.9-3.8c.9-1.8.4-3.1-1-3.9-1.6-.8-2.7-.4-3.6 1.4l-1.9 3.9 4.6 2.4zM23.2 47.7l6.7-7.6 1.2 1-5.5 6.2 3.4 3 5-5.7 1.1 1-5 5.7 3.8 3.3 5.6-6.4 1.2 1.1-6.7 7.8-10.8-9.4zM43.3 37.4l-7.9-2.6 1.6-1.3 6.3 2.3-.7-6.7 1.5-1.2.7 8.4 8.3 2.7-1.7 1.3-6.6-2.4.7 7.1-1.5 1.2-.7-8.8zM50.5 23.6l5.2-2.9c1.3-.7 2.6-.9 3.6-.4.9.3 1.6 1 2.2 1.9 1.3 2.3.7 4.4-2 5.9L56.1 30l2.9 5.2-1.6.9-6.9-12.5zm4.9 5.1 3.3-1.8c1.8-1 2.1-2.3 1.3-3.8s-2.2-1.8-3.8-.9l-3.4 1.9 2.6 4.6zM66.6 15.5l9.6-3.3.5 1.5-7.9 2.7 1.5 4.3 7.1-2.4.5 1.4-7.1 2.4 1.6 4.8 8.1-2.8.5 1.6-9.8 3.4-4.6-13.6zM84.2 10.3l6.6-1c2.5-.4 4.4.9 4.8 3.2.3 1.7-.3 3.1-1.9 3.9v.1c1.5.3 2.1 1.2 2.6 3.3.5 2.2.8 2.8 1.1 2.9v.1l-2 .2c-.3-.2-.5-.7-1-3.1-.5-2.1-1.4-2.7-3.3-2.4l-3.9.6.9 6-1.8.3-2.1-14.1zm2.8 6.4 4.2-.6c2-.3 2.8-1.4 2.6-3-.3-1.7-1.2-2.5-3.3-2.2l-4.3.6.8 5.2zM102.7 8.4h1.8l.1 14.3h-1.8l-.1-14.3zM112.7 8.5l10 1.2-.2 1.6-8.2-1-.5 4.5 7.5.9-.2 1.5-7.5-.9-.6 5 8.5 1-.2 1.6-10.3-1.2 1.7-14.2zM130.9 11.5l1.8.6 3.2 11.4c.2.8.4 2.1.4 2.1l3.5-11.2 1.6.5-4.3 13.6-1.7-.6-3.2-11.4-.5-2-3.5 11.2-1.6-.5 4.3-13.7zM145.8 24.2c2-3.7 5.8-5.4 9.5-3.3 2.9 1.6 3.8 4.3 2.9 6.8l-1.5-.8c.6-1.7-.1-3.5-2.1-4.6-2.8-1.5-5.5-.1-7.1 2.8-1.7 3.1-1.1 6.1 1.5 7.5 2.4 1.3 4.4.3 5.6-1.5l1.6.9c-.7 1.2-2.1 2.3-3.4 2.7-1.4.4-2.9.1-4.5-.7-3.7-2-4.6-6-2.5-9.8zM167 28.5l7.9 6.4-1 1.2-6.5-5.2-2.8 3.5 5.9 4.8-1 1.2-5.9-4.8-3.2 3.9 6.7 5.4-1 1.3-8.1-6.5 9-11.2zM186.1 46.8l3.1 4.2c2.5 3.5 1.4 6.8-2.1 9.4s-7 2.4-9.6-1.1l-3-4.1 11.6-8.4zm-7.3 11.5c2 2.7 4.5 2.5 7.2.5s3.8-4.3 1.9-7l-2-2.7-9 6.6 1.9 2.6zM197 63.1l4.4 9.1-1.4.7-3.6-7.5-4.1 2 3.3 6.8-1.4.7-3.3-6.8-4.5 2.2 3.7 7.7-1.5.7-4.5-9.3 12.9-6.3zM194.8 81.5l.5 1.7c-2.3.9-3.1 2.6-2.4 5.2.5 1.9 1.8 3 3.5 2.6 1.9-.5 1.9-2.3 1.7-4.9-.1-2.6 0-4.9 2.6-5.6 2.3-.6 4.2.9 4.9 3.7 1 3.4-.4 5.4-2.8 6.4l-.5-1.6c1.9-.8 2.5-2.3 2-4.4-.5-1.9-1.7-2.9-3.1-2.5-1.6.4-1.6 2.1-1.4 4.3.2 2.8.2 5.5-2.9 6.3-2.6.7-4.6-1-5.4-3.9-1.1-3.9.6-6.4 3.3-7.3zM208.2 97.4l.2 1.8-14.2 2-.2-1.8 14.2-2zM196.8 118c-1.5-1.1-2.2-2.6-2.1-4.5 0-4 3.1-6.7 7.5-6.7 4.2 0 7.5 2.4 7.4 6.9 0 3.3-1.8 5.3-4.7 5.8v-1.9c1.9-.4 3.1-1.7 3.1-4 0-3.4-2.5-5-5.9-5.1-3.5 0-5.9 2-5.9 4.9 0 2.9 2 4.3 4.4 4.4h.3v-4.3h1.6l-.1 6.1-7.6-.1v-1.2l2-.3zM208.3 128.3l-.4 1.9-11 4.4c-.8.3-2 .7-2 .7l11.5 2.4-.3 1.6-14-2.9.4-1.8 11.1-4.4c.8-.3 2-.7 2-.7l-11.5-2.3.3-1.6 13.9 2.7z'
      className='st1'
    />
    <path
      className='st0'
      d='M172.9 171.6c-32.6 37.5-89.5 41.5-127 8.8-4.8-4.2-9.2-8.9-13-14'
    />
    <path
      className='st18'
      transform='rotate(-61.151 183.79589508 156.01367246)'
      d='M181.8 154h4v4h-4z'
    />
    <path
      className='st18'
      transform='rotate(-22.765 22.00262333 147.39261917)'
      d='M20 145.4h4v4h-4z'
    />
    <path
      transform='rotate(-45 105.26095603 74.35431201)'
      className='st2'
      d='M102.8 71.9h4.9v4.9h-4.9z'
    />
    <path
      d='m65.9 118.3-4.3-4.3 4.3-4.3 4.3 4.3-4.3 4.3zm-2.6-4.3 2.6 2.6 2.6-2.6-2.6-2.6-2.6 2.6z'
      fill='#3c388f'
    />
    <path
      transform='rotate(-45 144.67463387 113.71036665)'
      className='st2'
      d='M142.2 111.3h4.9v4.9h-4.9z'
    />
    <path
      transform='rotate(-45 105.23788795 153.06346681)'
      className='st2'
      d='M102.8 150.6h4.9v4.9h-4.9z'
    />
    <circle className='st4' cx='127' cy='126.2' r='7.9' />
    <circle className='st4' cx='87.4' cy='105.1' r='7.9' />
    <path
      className='st5'
      d='m115.4 128-5.5 3.1c-4.5 2.6-10.3 1.1-13-3.4h0c-2.6-4.5-1.1-10.4 3.5-13h0l11-6.3c4.5-2.6 6.1-8.4 3.5-13h0c-2.7-4.5-8.4-6-12.9-3.4l-12.4 7'
    />
    <circle className='st5' cx='122.3' cy='124.1' r='7.9' />
    <circle className='st5' cx='82.8' cy='103' r='7.9' />
    <path
      className='st5'
      d='m82.7 99.7 3.8 1.1-.9 4M79 105.1l7.5-4.3M119 125.3l2 2.1 4.9-6.4'
    />
  </svg>
)

export default UserExperienceDesign
